
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/we-queue-for-you/document-collection",
      function () {
        return require("private-next-pages/we-queue-for-you/document-collection/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/we-queue-for-you/document-collection"])
      });
    }
  